export const errCodeMap = {
  5300: '中台服务错误',
  4100: '参数错误',
  4101: '中台账户不存在',
  5100: '发送验证码失败',
  5200: '暂无账户，请先注册',
  5301: '身份证已被使用',
  5302: '面部识别认证失败',
  5303: '更新个人身份验证状态失败',
  5304: '更新身份验证信息失败',
  5305: '京东Pid已经被注册',
  5306: '商品已经被添加过',
  5308: '商品信息不存在，链接无效',
  5309: '添加Saas商品失败',
  5310: '添加中台商品失败',
  5314: '企鹅小店用户ExtInfo数据缺失',
  5315: '企鹅小店用户Token信息缺失',
  5307: '京东账号未绑定',
  5320: '企鹅小店账号未绑定',
  5321: '拼多多账号未绑定',
  5324: '拼多多Pid已经被注册',
  5325: '查询时间跨度过大',
  5313: '已存在多重绑定关系，请指定媒体账号',
  5311: '添加失败！需在【我的资料】页面绑定',
  5405: '当前媒体账户已和中台绑定，请切换媒体账户',
  5312: '媒体类型不支持',
  5400: '邀请码已过期',
  5401: '该用户已存在绑定关系',
  5101: '短信验证码错误或已过期',
  5500: '企业法人不匹配',
  5501: '企业统一社会信用代码不匹配',
  5502: '企业名称不匹配',
  5503: '企业地址不匹配',
  5504: '企业经营状态不符合条件',
  5505: '营业执照无效',
  5506: '企业认证服务出错',
  5403: '运营最多允许绑定10个',
  5404: '运营最多允许绑定5个',
  5201: '暂无账户，请先注册',
  5332: '微信账号已被绑定',
  5333: 'qq账号已被绑定',
  5334: '手机号已被绑定',
  5342: '中台账号已存在不需要绑定',
  5406: '不在k歌白名单内',
  5103: '发送短信验证码间隔小于一分钟',
  6001: '您好，当前商品为内测商品，请联系运营开通权限后添加',
  40500: '您的实名信息已注册过平台账号，请绑定已有账号',

  // 以下为新接口的新错误码
  42000: '该PID已经被其他用户绑定，请重新输入新的PID！', // 新接口的新错误码
  42001: 'PID账号填写错误，请重新输入！', // 新接口的新错误码
};

export class HttpError extends Error {
  constructor(code = 5300, msg = '中台服务错误') {
    super();
    this.code = code;
    this.msg = msg;
  }
}

export class Success extends HttpError {
  constructor(msg) {
    super();
    this.code = 0;
    this.msg = msg;
  }
}

export class ParamsError extends HttpError {
  constructor(msg = '参数错误') {
    super();
    this.code = 4100;
    this.msg = msg;
  }
}

export class MPUserNotExist extends HttpError {
  constructor(msg = '中台账户不存在') {
    super();
    this.code = 4101;
    this.msg = msg;
  }
}

export class SMSError extends HttpError {
  constructor(msg = '短信服务错误') {
    super();
    this.code = 5100;
    this.msg = msg;
  }
}

export class SessionError extends HttpError {
  constructor(msg = 'Session服务错误') {
    super();
    this.code = 5200;
    this.msg = msg;
  }
}

export class ECMPError extends HttpError {
  constructor(msg = '中台服务错误') {
    super();
    this.code = 5300;
    this.msg = msg;
  }
}

export class IDCardAlreadyBeUsed extends HttpError {
  constructor(msg = '身份证已被使用') {
    super();
    this.code = 5301;
    this.msg = msg;
  }
}

export class FaceAuthenticationFailed extends HttpError {
  constructor(msg = '面部识别认证失败') {
    super();
    this.code = 5302;
    this.msg = msg;
  }
}

export class UpdateCPAuthenticationStatusFailed extends HttpError {
  constructor(msg = '更新个人身份验证状态失败') {
    super();
    this.code = 5303;
    this.msg = msg;
  }
}

export class UpdateCertificationFailed extends HttpError {
  constructor(msg = '更新身份验证信息失败') {
    super();
    this.code = 5304;
    this.msg = msg;
  }
}

export class JDPidHasBeUsed extends HttpError {
  constructor(msg = 'JDPid已经被注册') {
    super();
    this.code = 5305;
    this.msg = msg;
  }
}

export class JDProductAlreadyImported extends HttpError {
  constructor(msg = 'JD商品已经被添加过') {
    super();
    this.code = 5306;
    this.msg = msg;
  }
}

export class SaaSJDNotExist extends HttpError {
  constructor(msg = 'JD账号未绑定') {
    super();
    this.code = 5307;
    this.msg = msg;
  }
}
export class JDProductInfoNotExist extends HttpError {
  constructor(msg = 'JD商品信息不存在，链接无效') {
    super();
    this.code = 5308;
    this.msg = msg;
  }
}
export class SaaSProductImportFailed extends HttpError {
  constructor(msg = '添加Saas商品失败') {
    super();
    this.code = 5309;
    this.msg = msg;
  }
}
export class MPProductImportFailed extends HttpError {
  constructor(msg = '添加中台商品失败') {
    super();
    this.code = 5310;
    this.msg = msg;
  }
}

export class MkAccountExtInfoMissing extends HttpError {
  constructor(msg = '企鹅小店用户ExtInfo数据缺失') {
    super();
    this.code = 5314;
    this.msg = msg;
  }
}

export class MkAccountExtInfoTokenMissing extends HttpError {
  constructor(msg = '企鹅小店用户Token信息缺失') {
    super();
    this.code = 5315;
    this.msg = msg;
  }
}
